if (objects.is_entreprises){
    let questions = Array.from(document.querySelectorAll(".question"))
    let reponses = Array.from(document.querySelectorAll(".reponse"))

    for (let i=0; i < questions.length; i++){
        questions[i].addEventListener('click', () => {

            if (reponses[i].classList.contains("visible")) {
                reponses[i].classList.remove("visible")
                questions[i].querySelector("svg").style.transform = "rotate(0deg)"
            } else {
                reponses[i].classList.add("visible")
                questions[i].querySelector("svg").style.transform = "rotate(90deg)"
            }
        })
    }

    const swiper_aventures_entreprises = new Swiper('.swiper-aventures-entreprises', {
        loop: true,
        slidesPerView: 1,  
        spaceBetween: 15,

        breakpoints: {
          // when window width is >= 320px
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },

        navigation: {
          nextEl: '.swiper-aventures-entreprises-next',
          prevEl: '.swiper-aventures-entreprises-prev',
        }
    })
} 